import { Trans, useTranslation } from 'next-i18next';
import type { FC } from 'react';
import React from 'react';

import womenPng from '@/public/assets/statistics/woman2.png';
import women2xPng from '@/public/assets/statistics/woman2@2x.png';
import { cn } from '@/utils';

import { Container } from '../Container';

interface HeroV2Props {
  h1TranslationKey: string;
}

export const HeroV2: FC<HeroV2Props> = ({ h1TranslationKey }) => {
  const { t } = useTranslation();

  return (
    <Container className="relative max-w-[848px] px-0 md:pb-[136px] md:pt-[78px] lg:pb-[144px] lg:pt-[98px] xl:pb-[170px] xl:pt-[123px]">
      <div className="mb-12 flex flex-col items-center justify-between pb-20 pt-9 md:mb-0 md:flex-row md:px-[2px] md:py-0 lg:max-w-[532px] lg:px-0">
        <div className="z-10 flex w-full flex-col md:w-2/3 lg:w-full">
          <h1 className="md:h2 mb-2 px-5 text-[32px] font-bold leading-[40px] text-blue-900 md:text-[40px] md:leading-[48px] md:tracking-[-0.64px] lg:px-0">
            <Trans
              i18nKey={h1TranslationKey}
              t={t}
              components={{
                blueText: <span className="text-blue-500" />,
              }}
            />
          </h1>
        </div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-[85%] top-24 flex h-[274px] w-[417px] items-center sm:left-[50%] sm:top-10 sm:h-[500px] sm:w-[716px] md:left-[60%] md:top-10 lg:left-[60%] xl:left-[68%]">
        <div className="shadow-image h-[30px] w-[20px] rounded-full bg-white sm:h-[200px] sm:w-[100px] md:h-[360px] md:w-[150px]" />
      </div>
      <div
        className={cn(
          'absolute right-[-290px] bottom-[-30px] lg:bottom-0 z-[5] h-[251px] w-[446px] min-[530px]:right-0 lg:left-[250px] lg:max-h-[430px] lg:min-h-[430px] lg:min-w-[620px] lg:max-w-[620px] xl:left-[50%]',
        )}
      >
        <picture className="mb-10 flex h-full w-[283px] text-transparent md:w-full">
          <source
            srcSet={`${womenPng} 1x, ${women2xPng} 2x`}
            type="image/png"
            media="(max-width: 320px)"
          />
          <img
            className="m-auto"
            src={womenPng.src}
            alt="women"
            width={womenPng.width}
            height={womenPng.height}
          />
        </picture>
      </div>
    </Container>
  );
};
